module.exports = __webpack_public_path__ + "img/bkg.f3be8ca4.png";